import { useState } from 'react';
import apiService from '../services/api';

export const usePatientsCrud = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createPatient = async (patientData) => {
    try {
      setLoading(true);
      setError(null);
      const result = await apiService.createPatient(patientData);
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const updatePatient = async (id, patientData) => {
    try {
      setLoading(true);
      setError(null);
      const result = await apiService.updatePatient(id, patientData);
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const deletePatient = async (id) => {
    try {
      setLoading(true);
      setError(null);
      const result = await apiService.deletePatient(id);
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    createPatient,
    updatePatient,
    deletePatient,
    loading,
    error
  };
};
